import { render, staticRenderFns } from "./SettingIcon.vue?vue&type=template&id=1f663c60&"
import script from "./SettingIcon.vue?vue&type=script&lang=ts&"
export * from "./SettingIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports